// This file can be toReplace during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/**
 * Used by angular to serve variables based on the the environment
 */
export const environment = {
  /**
   * This is a development environment
   */
  production: false,
  API_URL: 'http://localhost:5001',
  API_KEY: 'your-api-key',
  // Create a new token with write permissions at https://huggingface.co/settings/tokens
  HF_API_KEY: 'hf_xxx',
  
  // Azure OpenAI Configuration
  AZURE_OPENAI_ENDPOINT: 'https://ma-mukander-kumar.openai.azure.com',
  AZURE_OPENAI_API_KEY: '8kwznjgPF52E5LF0zGAucnZLPROuoMTJJyJVEGN4QNDJLQZJwwUTJQQJ99BEACfhMk5XJ3w3AAABACOGe445',
  AZURE_OPENAI_DEPLOYMENT: 'o4-mini',
  AZURE_OPENAI_API_VERSION: '2025-01-01-preview',
  
  // OpenRouter API keys have limits - if errors persist, create a new key at https://openrouter.ai/
  OPENROUTER_API_KEY: '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',

  GRADIO_URL: 'https://78902d0bb6e414c3b4.gradio.live'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
